<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import "lodash";
import { BaseAtom } from "components/cards/atoms";
import { SearchParticle } from "components/cards/particles/YinzCam";
export let container = undefined;
export let search = undefined;
</script>

<style></style>

<BaseAtom _isotope="SearchAtom" {...container}>
  <SearchParticle {...search} />
</BaseAtom>
